<template>
  <div class="warehouse-label-100x40">
    <div class="warehouse-label-100x40-page" v-for="(item, index) in printData" :key="index">
      <div class="warehouse-label-100x40-grid-number">{{ getGridNumber(item) }}</div>
      <img class="warehouse-label-100x40-qr-code" :src="item.url" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    printData: { type: Array }
  },
  mounted() {
    this.getQRcode()
  },
  methods: {
    // 二维码内容与其他库位唛头保持一致。
    getQRcode() {
      this.printData.forEach((item, index) => {
        this.$QRCode.toDataURL(
          `${item.floor_number}-${item.print_index || index + 1}`,
          { errorCorrectionLevel: 'L', margin: 0, width: 256 },
          (err, url) => {
            if (err) throw err
            item.url = url
            this.$forceUpdate()
          }
        )
      })
    },
    // 唛头只显示“】-”后的实际库位编号。
    getGridNumber(item) {
      if (!item.grid_number) return ''
      const gridNumber = String(item.grid_number)
      const separatorIndex = gridNumber.indexOf('】-')
      return separatorIndex === -1 ? gridNumber : gridNumber.slice(separatorIndex + 2)
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouse-label-100x40 {
  color: #000;
}

.warehouse-label-100x40-page {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 12mm;
  align-items: center;
  column-gap: 2mm;
  box-sizing: border-box;
  width: 100mm;
  height: 40mm;
  padding: 3mm 3mm 3mm 5mm;
  background: #fff;
  page-break-after: always;
}

.warehouse-label-100x40-grid-number {
  min-width: 0;
  font-size: 16mm;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.warehouse-label-100x40-qr-code {
  width: 12mm;
  height: 12mm;
}

@media print {
  @page {
    margin: 0;
  }

  .warehouse-label-100x40-page {
    width: 100mm !important;
    height: 40mm !important;
    padding: 3mm 3mm 3mm 5mm !important;
    page-break-after: always;
  }
}
</style>
